module.exports = __webpack_public_path__ + "static/img/solution.c5940c15.png";